import { getFingerprint } from '../helpers'

export default () => {
  // eslint-disable-next-line no-console
  getFingerprint().catch(console.error)
}
